module.exports = __webpack_public_path__ + "img/student_18.29df38f3.png";